"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPatchDigestStepDto = instanceOfPatchDigestStepDto;
exports.PatchDigestStepDtoFromJSON = PatchDigestStepDtoFromJSON;
exports.PatchDigestStepDtoFromJSONTyped = PatchDigestStepDtoFromJSONTyped;
exports.PatchDigestStepDtoToJSON = PatchDigestStepDtoToJSON;
exports.PatchDigestStepDtoToJSONTyped = PatchDigestStepDtoToJSONTyped;
/**
 * Check if a given object implements the PatchDigestStepDto interface.
 */
function instanceOfPatchDigestStepDto(value) {
    if (!('selection' in value) || value['selection'] === undefined)
        return false;
    return true;
}
function PatchDigestStepDtoFromJSON(json) {
    return PatchDigestStepDtoFromJSONTyped(json, false);
}
function PatchDigestStepDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'selection': json['selection'],
    };
}
function PatchDigestStepDtoToJSON(json) {
    return PatchDigestStepDtoToJSONTyped(json, false);
}
function PatchDigestStepDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'selection': value['selection'],
    };
}
